/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Bot } from '../models/Bot';
import type { BotAdd } from '../models/BotAdd';
import type { BotsList } from '../models/BotsList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BotsService {
    /**
     * Get bots
     * @returns BotsList OK
     * @throws ApiError
     */
    public static listBots(): CancelablePromise<BotsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bots',
        });
    }
    /**
     * Add bot
     * Add bot in list
     * @param requestBody Add bot
     * @returns Bot OK
     * @throws ApiError
     */
    public static botAdd(
        requestBody?: BotAdd,
    ): CancelablePromise<Bot> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bots',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get bot by id
     * @param id bot_id
     * @returns Bot OK
     * @throws ApiError
     */
    public static getBot(
        id: number,
    ): CancelablePromise<Bot> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bots/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update bot
     * update bot by id
     * @param id bot_id
     * @param requestBody Update bot data
     * @returns Bot OK
     * @throws ApiError
     */
    public static updateBot(
        id: number,
        requestBody?: BotAdd,
    ): CancelablePromise<Bot> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/bots/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
